<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $tc('movie', 1) }}</div>
      <div>
        <router-link
          class="btn-blue"
          @click.native="goToRoute('/cinema-manager/edit-movies')"
          to
        >{{ $t('edit') }}</router-link>
        <router-link class="btn-blue" to="movies">{{ $tc('movie', 1) }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>
    <div class="all-details-container">
      <div class="col-12">
        <!-- MOVIE DETAILS -->
        <div class="mb-4">
          <h3 class="text-blue font-weight-bold mb-3">{{ MovieContainer.movieTitle }}</h3>
          <p class="mb-1">
            <span class="font-weight-bold mr-1">{{ $tc('country', 1) }} :</span>
            {{ MovieContainer.country_name }}
          </p>
          <p class="mb-1">
            <span class="font-weight-bold mr-1">{{ $tc('productioncompany', 1) }} :</span>
            <!-- {{ MovieContainer.productionCompany ? MovieContainer.productionCompany : ''}}. -->
            {{ MovieContainer.productionCompany && MovieContainer.productionCompany.length > 0 ? MovieContainer.productionCompany.map(x => x.production_name)
            .toString(): ''}}
          </p>
          <p class="mb-1">
            <span class="font-weight-bold mr-1">{{ $tc('genre', 1) }}:</span>
            <!-- Politics, social -->
            {{ MovieContainer.genres ? MovieContainer.genres.length > 0 && MovieContainer.genres.map(x => x.g_name)
            .toString() : ''}}
          </p>
        </div>

        <!-- DETAILS AND POSTER TABS -->
        <div class="view-movie-tab mb-4">
          <b-card no-body>
            <div class="bn-tabs-nav bg-light">
              <button
                v-for="(MovieContent, MovieContentIndex) in MovieContentContainer"
                :key="MovieContentIndex"
                :class="['btn-tab-title ',{'active': MovieContentIndex == activeClass}]"
                @click.prevent.stop="onChangeTabHandler($event,MovieContentIndex)"
              >
                <strong>{{ MovieContent.langauge }}</strong>
              </button>
            </div>

            <div class="bn-tabs-content">
              <div
                class="col-12"
                v-for="(MovieContent, MovieContentIndex) in MovieContentContainer"
                :key="MovieContentIndex"
              >
                <div v-if="MovieContentIndex === activeClass">
                  <div class="row">
                    <div class="col-8">
                      <div class="section-title mb-4">{{ MovieContent.movieContentTitle }}</div>
                      <div class="mb-2">
                        <span class="font-weight-bold">Directors -</span>
                        <!-- Saif, Pratik -->
                        {{ MovieContent.movieCastAndCrewList && MovieContent.movieCastAndCrewList.length > 0 ? MovieContent.movieCastAndCrewList.filter((x)=> x.crew_title === 'Director').map((y)=> y.person_name).toString() : '' }}
                      </div>
                      <div class="mb-2">
                        <span class="font-weight-bold">Producer -</span>
                        {{ MovieContent.movieCastAndCrewList && MovieContent.movieCastAndCrewList.length > 0 ? MovieContent.movieCastAndCrewList.filter((x)=> x.crew_title === 'Producer').map((y)=> y.person_name).toString() : '' }}
                      </div>
                      <div class="mb-2">
                        <span class="font-weight-bold">Actors -</span>
                        <!-- Saif, Pratik, Abc -->
                        {{ MovieContent.movieCastAndCrewList && MovieContent.movieCastAndCrewList.length > 0 ? MovieContent.movieCastAndCrewList.filter((x)=> x.crew_title === 'Actor').map((y)=> y.person_name).toString() : '' }}
                      </div>
                      <div class="mb-2">
                        <span class="font-weight-bold">Plot -</span>
                        {{ MovieContent.movieDescription }}
                      </div>
                    </div>

                    <div class="col-4 text-center">
                      <div
                        v-for="(moviePoster, MoviePostersIndex) in MovieContent.moviePosters"
                        :key="MoviePostersIndex"
                        class="mb-3"
                        v-if="moviePoster.image_setting_path.length > 0"
                      >
                        <p
                          class="mb-1 font-weight-bold"
                        >{{ moviePoster.image_setting_width }}x{{ moviePoster.image_setting_height }}</p>
                        <a
                          :href="moviePoster.image_setting_path"
                          data-fancybox
                          data-caption="120x120"
                        >
                          <div class="img-size-1">
                            <!-- <img src="@/assets/img/temp/movie-listing.png" class="img-fluid" /> -->
                            <img :src="BASE_URL+moviePoster.image_setting_path" class="img-fluid" />
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>

        <!-- MOVIE DETAILS & DISTRIBUTION -->
        <div class="mb-4">
          <h6 class="font-weight-bold text-blue mb-2">Movie Details</h6>

          <!-- SECTION -->
          <div
            v-for="(movieLangaugeFormatDistributor,movieLangaugeFormatDistributorIndex) in MovieContainer.movieLangaugeFormatDistributor"
            :key="movieLangaugeFormatDistributorIndex"
          >
            <p class="ml-2 d-flex align-items-center">
              <i class="fa fa-asterisk small mr-1" aria-hidden="true"></i>
              <!-- Hindi - 2D - Trailer : -->
              {{ movieLangaugeFormatDistributor.lang_name }} - {{ movieLangaugeFormatDistributor.format_name }} - Trailer :
              <a
                data-fancybox
                :href="movieLangaugeFormatDistributor.trailer"
              >{{ movieLangaugeFormatDistributor.trailer }}</a>
            </p>
            <br />
            <p class="ml-2 d-flex align-items-center">
              <i class="fa fa-asterisk small mr-1" aria-hidden="true"></i>
              <!-- Hindi - 2D - Trailer : -->
              Thumbnail :
              <a
                data-fancybox
                :href="_GetImagePath(movieLangaugeFormatDistributor.md_thumbnail_url)"
              >{{ _GetImagePath(movieLangaugeFormatDistributor.md_thumbnail_url) }}</a>
            </p>
            <!-- <div class="mb-1">
              <b-button @click="showMsgBoxTwo">msgBoxConfirm with options</b-button>
              Return value: {{ String(boxTwo) }}
            </div>-->

            <table class="table border">
              <thead class="thead-light">
                <tr>
                  <th>DISTRIBUTORS</th>
                  <th>SUB-DISTRIBUTORS</th>
                  <th>CINEMAS</th>
                  <!-- <th>LOCATION</th> -->
                  <!-- <th>FROM DATE - TO DATE</th> -->
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(MovieDistributor, movieDistributorsIndex) in movieLangaugeFormatDistributor.movieDistributors"
                  :key="movieDistributorsIndex"
                >
                  <td>{{ MovieDistributor.distributor_name }}</td>
                  <td>{{ MovieDistributor.sub_distributor_name }}</td>
                  <td>{{ MovieDistributor.selected_cinema[0].cine_name }}</td>
                  <!-- <td>{{ MovieDistributor.city_name }} ( {{ MovieDistributor.state_name }} )</td> -->
                  <!-- <td>{{ MovieDistributor.fromdate | dateparse }}&nbsp;to&nbsp;{{ MovieDistributor.todate | dateparse }}</td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- RATING RELEASEDATE AND RUNTIME   -->
        <div class="mb-4">
          <table class="table border">
            <thead class="thead-light">
              <tr>
                <th>{{$t('censorrating')}}</th>
                <th>RELEASE DATE</th>
                <th>RUNTIME</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(movieRating,movieRatingIndex) in MovieContainer.movieRatings"
                :key="movieRatingIndex"
              >
                <td>{{ movieRating.country_name}} - {{ movieRating.rating }}</td>
                <td>{{ movieRating.releaseDate | dateparse }}</td>
                <td>{{ movieRating.runTime }} mins</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";

export default {
  data() {
    return {
      boxTwo: "",
      activeClass: 0,
      tableId: null,

      MovieContainer: {
        movie_id: null,
        movie_title: "",
        country_name: "",
        country_id: null,
        productionCompany: null,
        genres: [],
        movieRatings: [],
        movieLangaugeFormatDistributor: []
      },
      MovieContentContainer: []
    };
  },
  beforeMount() {
    const { movie_id } = this.$route.query;
    // console.log("this.$route.query :", this.$route.query);
    if (movie_id) {
      this.tableId = movie_id;

      this.getViewList(movie_id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    goToRoute: function(path) {
      this.$router.push({
        path: path,
        query: {
          movie_id: this.tableId
        }
      });
    },
    onChangeTabHandler: function(event, index) {
      this.activeClass = index;
    },
    getViewList: function(movie_id) {
      let loader = this.$loading.show();

      this.MovieContentContainer = [];
      MovieService.GetEditMoviesDetails({ movie_id })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            Object.assign(this.MovieContainer, data.MovieContainer);
            this.MovieContentContainer = data.MovieContentContainer;
          } else {
            // Show Message Here
            console.log("data.message :", data.message);
          }
          // setTimeout(() => loader.hide(), 1000);
        })
        .catch(error => {
          // Handle Catch
          console.log("error :", error);
        })
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    showMsgBoxTwo() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(
          `<img src="http://localhost:3800/uploads/movies/1566478762041-AppImage-666*999.jpg" alt="Smiley face" width="42" height="42">`,
          {
            title: "Confirmation",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true
          }
        )
        .then(value => {
          this.boxTwo = value;
        })
        .catch(err => {
          // An error occurred
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MoviesComponents/viewMovies.vue